<div class="page-header full-bg">
  <div class="blur-bg page-header-content">
    <h1 class="p-text-center p-text-white page-title p-my-1">
      యాత్ర సందర్శిని
    </h1>
    <hr class="special-line" />
    <h2 class="p-text-center page-sub-title p-my-1">
      ఇందులో మీరు తీర్థయాత్రల సమాచారమును చూడవచ్చును. నచ్చినవాటికి కాల్ చేసి
      సమాచారమును తెలుసుకోవచ్చును.అలానే బుక్ చేసుకోవచ్చును,మీ ఆత్మీయులతో
      పంచుకోవచ్చును.
    </h2>
  </div>
</div>
<div class="page-content p-text-center">
  <app-yatra-card *ngFor="let yatra of yatraSandharshini" [yatraObj]="yatra">
  </app-yatra-card>
  <app-loader [enable]="contentLoading"></app-loader>
</div>
